module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExMultiple,
      "code": _vm.ExMultipleCode,
      "title": "Multiple",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExIcons,
      "code": _vm.ExIconsCode,
      "title": "Icons",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1522872d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/select/Select.vue
// module id = 1485
// module chunks = 29